// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-select.select {
  margin: 0px;
}

.row {
  align-items: center;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.red {
  color: #d3001d;
}

.globalLimit {
  padding-bottom: 10px;
}

.timeDelete, .timeRolloverPeriod, .timeRemoved, .timeAmountUsed, .timeNewLimitEffective, .timePendingLimitEffective {
  display: none;
  width: 100%;
}

.button-row {
  justify-content: center;
  display: grid;
}

.deposit-column {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label-colum {
  display: flex;
  align-items: center;
}

.label-text {
  text-overflow: "-";
  white-space: nowrap;
}

.deposit-column {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

hr {
  border: 0;
  height: 1px;
  background: #C2C2C2;
}

.error-message {
  color: var(--ion-color-danger);
  font-size: 12px;
  margin-top: 4px;
}

.limit-section {
  display: flex;
  flex-direction: column;
}
.limit-section .limit-info {
  align-items: center;
  justify-content: space-between;
}
.limit-section .limit-info .label-text {
  font-size: 16px;
  font-weight: 500;
}
.limit-section .limit-info .timeDelete {
  display: flex;
  justify-content: flex-end;
}
.limit-section .new-limit-row {
  align-items: center;
}
.limit-section .new-limit-row h5 {
  margin: 0;
}
.limit-section .new-limit-row ion-input {
  --padding-start: 10px;
}

.section-divider {
  margin: 20px 0;
  border: none;
  height: 1px;
  background-color: var(--ion-color-light-shade);
}

.rollover-period {
  display: none;
  width: 100%;
}

.new-limit-effective {
  display: none;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/limits/set-time-limits/set-time-limits.component.scss"],"names":[],"mappings":"AACA;EACE,WAAA;AAAF;;AAGA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,aAAA;EACA,WAAA;AAAF;;AAGA;EACE,uBAAA;EACA,aAAA;AAAF;;AAIA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,kBAAA;EACA,mBAAA;AADF;;AAIA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;;AAIA;EACE,SAAA;EACA,WAAA;EACA,mBAAA;AADF;;AAIA;EACA,8BAAA;EACA,eAAA;EACA,eAAA;AADA;;AAIA;EAEA,aAAA;EACA,sBAAA;AAFA;AAOA;EACA,mBAAA;EACA,8BAAA;AALA;AAQA;EACE,eAAA;EACA,gBAAA;AANF;AASA;EACE,aAAA;EACA,yBAAA;AAPF;AAWA;EACA,mBAAA;AATA;AAWA;EACE,SAAA;AATF;AAYA;EACE,qBAAA;AAVF;;AAeA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,8CAAA;AAZA;;AAeA;EACA,aAAA;EACA,WAAA;AAZA;;AAeA;EACA,aAAA;EACA,WAAA;AAZA","sourcesContent":["\nion-select.select {\n  margin: 0px;\n}\n\n.row {\n  align-items: center;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n\n.red {\n  color: #d3001d;\n}\n\n.globalLimit {\n  padding-bottom: 10px;\n}\n\n.timeDelete, .timeRolloverPeriod, .timeRemoved, .timeAmountUsed, .timeNewLimitEffective, .timePendingLimitEffective {\n  display: none;\n  width: 100%;\n}\n\n.button-row {\n  justify-content: center;\n  display: grid;\n\n}\n\n.deposit-column {\n  flex-direction: row;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.label-colum {\n  display: flex;\n  align-items: center;\n}\n\n.label-text {\n  text-overflow: \"-\";\n  white-space: nowrap;\n}\n\n.deposit-column {\n  flex-direction: row;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\nhr {\n  border: 0;\n  height: 1px;\n  background: #C2C2C2;\n}\n\n.error-message {\ncolor: var(--ion-color-danger);\nfont-size: 12px;\nmargin-top: 4px;\n}\n\n.limit-section {\n// margin-bottom: 20px;\ndisplay: flex;\nflex-direction: column;\nh4 {\n// margin-bottom: 10px;\n}\n\n.limit-info {\nalign-items: center;\njustify-content: space-between;\n// margin-bottom: 10px;\n\n.label-text {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.timeDelete {\n  display: flex;\n  justify-content: flex-end;\n}\n}\n\n.new-limit-row {\nalign-items: center;\n\nh5 {\n  margin: 0;\n}\n\nion-input {\n  --padding-start: 10px;\n}\n}\n}\n\n.section-divider {\nmargin: 20px 0;\nborder: none;\nheight: 1px;\nbackground-color: var(--ion-color-light-shade);\n}\n\n.rollover-period{\ndisplay: none;\nwidth: 100%;\n}\n\n.new-limit-effective{\ndisplay: none;\nwidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
